import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--white)",
          "--normal-text": "var(--gray-700)",
          "--normal-border": "var(--gray-100)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
